import e from "./td-longtail-vue-components117.js";
/* empty css                              */
import o from "./td-longtail-vue-components98.js";
var n = function() {
  var t = this, r = t._self._c, a = t._self._setupProxy;
  return r(a.LinkButton, { staticClass: "forward-backward-button", class: { "forward-backward-button__left": t.direction === "left" }, attrs: { type: "button", tag: "button", primary: t.primary, outline: t.outline, secondary: t.secondary, disabled: t.disabled, "icon-only": "" }, on: { click: function(l) {
    return t.$emit("clicked");
  } } }, [r("svg", { staticClass: "forward-backward-button__svg", attrs: { viewBox: "0 0 68 68", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", fill: "currentColor" } }, [r("path", { attrs: { d: "M23.426 1.95A3.7 3.7 0 0 0 20.713.765a3.74 3.74 0 0 0-3.702 3.698c0 .93.355 1.826.985 2.51L42.946 34l-24.96 27.038a3.698 3.698 0 1 0 5.44 5.011L52.994 34z" } })])]);
}, s = [], i = /* @__PURE__ */ o(
  e,
  n,
  s,
  !1,
  null,
  "e0ae4623"
);
const f = i.exports;
export {
  f as default
};
